import isSMIMEItem from './isSMIMEItem';
import isMeetingMessage from 'owa-meeting-message/lib/utils/isMeetingMessage';
import Item from 'owa-service/lib/contract/Item';

/**
 * Both S/MIME reply and forward are allowed on the below item class
 */
const SMIME_SUPPORTED_ITEM_CLASSES = ['IPM.Note', 'REPORT.IPM.Note', 'IPM.Note.Rules', 'IPM.Post'];

const isSmimeSupportedForItem = (item: Item, isReply: boolean): boolean => {
    if (isSMIMEItem(item) || !item.ItemClass) {
        return true;
    }

    const isMeetingOrAppointment = isMeetingMessage(item);
    if (isReply && isMeetingOrAppointment) {
        /**
         * Allow reply meeting requests/responses and appointments
         * Forwards aren't supported because a forward will create a new meeting
         * and S/MIME is only supported for email.
         */
        return true;
    }

    return SMIME_SUPPORTED_ITEM_CLASSES.some(
        supportedItemClass => item.ItemClass.indexOf(supportedItemClass) === 0
    );
};

export default isSmimeSupportedForItem;
